import { useState } from "react";
import { Menu, X, Facebook, Instagram, Youtube } from "lucide-react";
import { NAV_LINKS, SOCIAL_LINKS } from "../data/siteData";

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 left-0 right-0 z-50">
            <div className="cmyk-strip" data-testid="cmyk-strip">
                <span className="c" /><span className="m" /><span className="y" /><span className="k" />
            </div>
            <div className="backdrop-blur-md bg-white/85 border-b border-zinc-200/70">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <a href="#home" data-testid="nav-brand-logo" className="flex items-center">
                            <img src="/assets/logo-horizontal-charcoal.png" alt="Studio Arti Grafiche" className="h-9 sm:h-10 w-auto" />
                        </a>

                        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-menu">
                            {NAV_LINKS.map((link) => (
                                <a
                                    key={link.id}
                                    href={`#${link.id}`}
                                    data-testid={link.testid}
                                    className="text-sm font-medium text-zinc-600 hover:text-[#FF0066] transition-colors duration-200"
                                >
                                    {link.label}
                                </a>
                            ))}
                        </nav>

                        <div className="hidden lg:flex items-center gap-4">
                            <div className="flex items-center gap-2">
                                <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" data-testid="nav-social-facebook" aria-label="Facebook" className="p-2 text-zinc-500 hover:text-[#FF0066] transition-colors duration-200">
                                    <Facebook size={16} />
                                </a>
                                <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" data-testid="nav-social-instagram" aria-label="Instagram" className="p-2 text-zinc-500 hover:text-[#FF0066] transition-colors duration-200">
                                    <Instagram size={16} />
                                </a>
                                <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" data-testid="nav-social-youtube" aria-label="YouTube" className="p-2 text-zinc-500 hover:text-[#FF0066] transition-colors duration-200">
                                    <Youtube size={16} />
                                </a>
                            </div>
                            <a
                                href="#contatti"
                                data-testid="nav-cta-button"
                                className="bg-[#0E0E10] text-white text-sm font-semibold px-5 py-2.5 hover:bg-[#FF0066] transition-colors duration-300"
                            >
                                Richiedi Preventivo
                            </a>
                        </div>

                        <button
                            data-testid="nav-mobile-toggle"
                            className="lg:hidden p-2 text-zinc-700"
                            onClick={() => setOpen(!open)}
                            aria-label="Menu"
                        >
                            {open ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </div>

                {open && (
                    <div className="lg:hidden border-t border-zinc-200 bg-white" data-testid="nav-mobile-menu">
                        <div className="px-4 py-4 flex flex-col gap-1">
                            {NAV_LINKS.map((link) => (
                                <a
                                    key={link.id}
                                    href={`#${link.id}`}
                                    data-testid={`nav-mobile-${link.testid}`}
                                    onClick={() => setOpen(false)}
                                    className="py-3 px-2 text-base font-medium text-zinc-700 hover:text-[#FF0066] border-b border-zinc-100 transition-colors duration-200"
                                >
                                    {link.label}
                                </a>
                            ))}
                            <a
                                href="#contatti"
                                data-testid="nav-mobile-cta"
                                onClick={() => setOpen(false)}
                                className="mt-3 bg-[#0E0E10] text-white text-center text-sm font-semibold px-5 py-3 hover:bg-[#FF0066] transition-colors duration-300"
                            >
                                Richiedi Preventivo
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};
